import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { manageRoutes } from "@/router/index.js";
export default {
  __name: 'ManageAside',
  setup(__props) {
    const $route = useRoute();

    // 处理菜单项，过滤隐藏的项
    const menuItems = computed(() => {
      return manageRoutes.filter(route => !route.meta?.hidden);
    });

    // 解析完整路径
    const resolvePath = (parentPath, childPath) => {
      // 移除父路径末尾的斜杠和子路径开头的斜杠
      const parent = parentPath.endsWith("/") ? parentPath.slice(0, -1) : parentPath;
      const child = childPath.startsWith("/") ? childPath.slice(1) : childPath;
      return `${parent}/${child}`;
    };
    const activeMenu = computed(() => {
      return $route.path;
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": activeMenu.value,
        class: "manage-aside",
        "background-color": "#0e0a07",
        "text-color": "#eeddc8",
        "active-text-color": "#e85d1a",
        router: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, route => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: route.path
          }, [route.children && route.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: route.path
          }, {
            title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(route.meta?.title || route.name), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children.filter(c => !c.meta?.hidden), child => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: child.path,
                index: resolvePath(route.path, child.path)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(child.meta?.title || child.name), 1)]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: route.path
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(route.meta?.title || route.name), 1)]),
            _: 2
          }, 1032, ["index"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["default-active"]);
    };
  }
};